module.exports = __webpack_public_path__ + "img/instabet_loading.c3bc0916.gif";